import React from "react";
import { connect } from "react-redux";
import { compose, withHandlers } from "recompose";
import { reduxForm, Field, SubmissionError } from "redux-form";
import { forEach, find } from "lodash";

import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";
import Button from "react-md/lib/Buttons/Button";

import TextField from "../form/TextField";
import AutocompleteField from "../form/AutocompleteField";

import { setActiveForm } from "../../actions/appActions";
import {
  updateOrganization,
  getOrganization
} from "../../actions/resourceActions";
import {
    putJSONOrNull, putJSONOrNull_result_IGNORE
} from "../../actions/requestActions";
import { getUsers } from "../../actions/userActions";
import {DebugElement} from "../../Atollon/debug";
import {getApiPrefix_touch} from "../../constants";

const Info = ({
  organization,
  handleSubmit,
  activeForm,
  setActiveForm,
  users,
  getUsers,
  change,
  putJSONOrNull,
  state
}) => {
  const optionsAutocomplete = [];
  if (users)
    forEach(users, item =>
      optionsAutocomplete.push({
        label: item.name,
        value: item.id
      })
    );

  return (
    <Card className="margin-bottom-small">
      <DebugElement text="src/components/organization/info.js BEGIN"/>
      {activeForm === "organizationUpdateForm" ? (
        <CardText>
          <form onSubmit={handleSubmit}>
            <div className="flex-row">
              <p className="info-label">ID:</p>
              <p>{organization.ident}</p>
            </div>
            <div className="flex-row">
              <p className="info-label">Atollon ID:</p>
              <p>{organization.atollonId}</p>
            </div>
            <div className="flex-row">
              <p className="info-label">Postfix:</p>
              <p>{organization.postfix}</p>
            </div>
            <div className="flex-row">
              <p className="info-label">Složka:</p>
              <p>{organization.folder}</p>
            </div>
            <Field
              component={TextField}
              label="Poznámky"
              name="notes"
              rows={5}
            />
            <Field
              component={AutocompleteField}
              label="Fakturační kontakt"
              name="billingContact"
              data={optionsAutocomplete}
              onChange={(e, value) => {
                getUsers(value);
              }}
              onAutocomplete={value => {
                if (find(users, u => u.id === value))
                  change(
                    "billingContact",
                    find(users, u => u.id === value).name
                  );
              }}
            />
            <div className="flex-row flex-right">
              <Button
                flat
                label="Zrušit"
                className="btn"
                onClick={() => setActiveForm(null)}
              />
              <Button
                flat
                primary
                label="Odeslat"
                type="submit"
                className="btn btn-primary"
              />
            </div>
          </form>
        </CardText>
      ) : (
        <CardText

        >
          <div className="flex-row">
            <p className="info-label">ID:</p>
            <p>{organization.ident}</p>
          </div>
          <div className="flex-row">
            <p className="info-label">Atollon ID:</p>
            <p>{organization.atollonId}</p>
          </div>
          <div className="flex-row">
            <p className="info-label">Postfix:</p>
            <p>{organization.postfix}</p>
          </div>
          <div className="flex-row">
            <p className="info-label">Složka:</p>
            <p>{organization.folder}</p>
          </div>
          <div className="flex-row">
            <p className="info-label">Poznámky:</p>
            <p>{organization.notes}</p>
          </div>
          <div className="flex-row">
            <p className="info-label">Fakturační kontakt:</p>
            <p>
              {organization.billingContact
                ? organization.billingContact.name
                : ""}
            </p>
          </div>

            <Button
                flat
                className="btn btn-primary md-btn md-btn-text touchButton-3 touchButton-shape3"
                label="Změnit informace o instanci"
                onClick={() => {
                setActiveForm("organizationUpdateForm");
            }}
            />

            <div className="touchButtons-spaceBetween" />

            <Button
                flat
                className="btn btn-primary md-btn md-btn-text touchButton-4 touchButton-shape3"
                label="Nastavit moje požadavky pro osobní užití v Lagoon"
                onClick={ async () => {

                    console.log( {organization, state});

                    if( organization.id && state && state.app && state.app.user && state.app.user.identifier )
                    {
                      if( window.confirm( "Nastavit moje požadavky pro osobní užití v Lagoon?" ))
                      {
                          let organizationInstanceUuid = organization.id;
                          let userId = state.app.user.identifier;
                          if( await putJSONOrNull({url: `${getApiPrefix_touch()}/requestEndpoint?organizationInstance=${organizationInstanceUuid}&userId=${userId}`, result: putJSONOrNull_result_IGNORE }) !== null )
                          {
                              alert( "Požadavky nastaveny pro osobní použití");
                          }
                          else
                          {
                              alert( "Chyba při nastavování požadavků pro osobní použití");
                          }
                      }
                    }
                }}
            />

            <div className="touchButtons-spaceBetween" />

            <Button
                flat
                className="btn btn-primary md-btn md-btn-text touchButton-4 touchButton-shape3"
                label="Nastavit moje požadavky pro celou organizaci"
                onClick={ async () => {

                    console.log( {organization, state});

                    if( organization.id && state && state.app && state.app.user && state.app.user.identifier )
                    {
                        if( window.confirm( "Nastavit moje požadavky pro celou organizaci?" ))
                        {
                            let organizationInstanceUuid = organization.id;
                            let userId = state.app.user.identifier;
                            if( await putJSONOrNull({url: `${getApiPrefix_touch()}/requestEndpoint?organizationInstance=${organizationInstanceUuid}&userId=${userId}&organization=true`, result: putJSONOrNull_result_IGNORE }) !== null )
                            {
                                alert( "Moje požadavky nastaveny pro celou organizaci");
                            }
                            else
                            {
                                alert( "Chyba při nastavování požadavků pro moji organizaci");
                            }
                        }
                    }
                }}
            />

        </CardText>
      )}
        <DebugElement text="src/components/organization/info.js END"/>
    </Card>
  );
};

export default compose(
  connect(
    ( state ) => {
      let { app: { form: { activeForm } }, resource: { users } } = state;
      return {
        activeForm,
        users,
        state
    }},
    {
      setActiveForm,
      updateOrganization,
      getOrganization,
      getUsers,
      putJSONOrNull
    }
  ),
  withHandlers({
    onSubmit: () => async (formData, dispatch, props) => {
      const {
        setActiveForm,
        updateOrganization,
        getOrganization,
        host,
        server,
        organization,
        users
      } = props;

      if (
        formData.billingContact &&
        formData.billingContact !== "" &&
        !find(users, u => u.name === formData.billingContact)
      ) {
        throw new SubmissionError({
          billingContact: "Uživatel neexistuje!"
        });
      }

      if (
        await updateOrganization({
          ...organization,
          ...formData,
          billingContact:
            formData.billingContact && formData.billingContact !== ""
              ? {
                  id: find(users, u => u.name === formData.billingContact).id
                }
              : null
        })
      ) {
        await getOrganization(host.id, server.id, organization.id);
        setActiveForm(null);
      } else {
        throw new SubmissionError({
          billingContact: "Update se nepodařil."
        });
      }
    }
  }),
  reduxForm({ form: "organizationUpdateForm", enableReinitialize: true })
)(Info);



// WEBPACK FOOTER //
// ./src/components/organization/Info.js